import React from 'react';
import iconTemplate from './IconTemplate';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="-0.625 -0.625 24 24"
        id="Keyboard-Wireless--Streamline-Flex"
        height="24"
        width="24"
    >
        <g id="keyboard-wireless--remote-device-wireless-electronics-qwerty-keyboard-bluetooth">
            <path
                id="Intersect"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M1.2288965 15.826265000000001c0.23264474999999998 1.5412474999999999 1.51239725 2.7346475 3.0655235000000003 2.8659475C6.5778375 18.885425 8.946535 19.09375 11.375 19.09375c2.428465 0 4.797162500000001 -0.208325 7.080612500000001 -0.4015375 1.5530125 -0.1313 2.8328625 -1.3247 3.0655625 -2.8659475C21.7390875 14.38250125 21.9375 12.89481375 21.9375 11.375c0 -1.51983 -0.1984125 -3.0075012500000002 -0.41632499999999995 -4.451265 -0.2327 -1.541215 -1.5125499999999998 -2.734615 -3.0655625 -2.8660125C16.1721625 3.8645424999999998 13.803465000000001 3.65625 11.375 3.65625c-2.428465 0 -4.797162500000001 0.2082925 -7.08058 0.4014725 -1.55312625 0.1313975 -2.83287875 1.3247975 -3.0655235000000003 2.8660125C1.01096125 8.367498750000001 0.8125 9.855170000000001 0.8125 11.375c0 1.51981375 0.19846125 3.0075012500000002 0.41639650000000006 4.451265Z"
                strokeWidth="1.25"
            ></path>
            <path
                id="Vector 122"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5.3217125 7.72965375h1.33573375"
                strokeWidth="1.25"
            ></path>
            <path
                id="Vector 211"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5.3217125 11.197257500000001h1.33573375"
                strokeWidth="1.25"
            ></path>
            <path
                id="Vector 209"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.70771 7.72965375h1.33573375"
                strokeWidth="1.25"
            ></path>
            <path
                id="Vector 212"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.70771 11.197257500000001h1.33573375"
                strokeWidth="1.25"
            ></path>
            <path
                id="Vector 210"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16.092895000000002 7.72965375h1.3357175000000001"
                strokeWidth="1.25"
            ></path>
            <path
                id="Vector 213"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16.092895000000002 11.197257500000001h1.3357175000000001"
                strokeWidth="1.25"
            ></path>
            <path
                id="Vector 208"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m5.3217125 15.02034625 12.106575 0"
                strokeWidth="1.25"
            ></path>
        </g>
    </svg>,
) as React.FC;
